import { render, staticRenderFns } from "./NotificationCentre.vue?vue&type=template&id=72434e67&"
import script from "./NotificationCentre.vue?vue&type=script&lang=js&"
export * from "./NotificationCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports